/*
 * File: Emoji.jsx
 * Project: seesaw-marketplace-app
 *
 * Created by Brendan Michaelsen on February 4, 2022 at 4:32 PM
 * Copyright © 2022 Seesaw Technologies, LLC. All rights reserved.
 *
 * Last Modified: July 20, 2022 at 3:58 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import React from 'react';
import PropTypes from 'prop-types';

// Styles
import * as S from './Emoji.styles';


/**
 * Component
 */

export const Emoji = ({ label, symbol, size }) => (
	<S.Emoji
		role="img"
		aria-label={label || ''}
		aria-hidden={label ? 'false' : 'true'}
		$size={size}
	>
		{symbol}
	</S.Emoji>
);


/**
 * Configuration
 */

Emoji.displayName = 'Emoji';
Emoji.propTypes = {
	size: PropTypes.number,
	label: PropTypes.string.isRequired,
	symbol: PropTypes.string.isRequired
};
Emoji.defaultProps = {
	size: 1.75
};
